import React from 'react'

import { useElementFontCss, useElementStyleCss } from 'services/Branding/hooks'
import { DeviceMode } from 'services/Store/Project/enums'

import type { CourseKitSize } from '../CourseKitTypes'
import ButtonCourseStyled from './styled/ButtonCourseStyled'

type ButtonDefaultType = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>

export interface IButtonPropsType extends ButtonDefaultType {
  /**
   * String for QA auto tests.
   */
  name: string
  /**
   * Whether the button is active or not.
   */
  active?: boolean
  /**
   * The size of the button.
   */
  size?: CourseKitSize
  /**
   * Whether the button should take up the full width of its container.
   */
  fluid?: boolean

  inheritColor?: boolean
  /**
   * The content of the button. Can be text, an Icon, or both.
   */
  children: React.ReactNode
  testData?: string
}

const ButtonCourse = React.forwardRef<HTMLButtonElement, IButtonPropsType>(
  (
    { name, active, fluid, disabled = false, children, inheritColor, testData, ...htmlProps },
    _ref,
  ) => {
    const { onClick } = htmlProps
    const buttonStyles = useElementStyleCss('button', DeviceMode.desktop)
    const font = useElementFontCss('button', DeviceMode.desktop)

    const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      if (!disabled) {
        onClick?.(e)
      }
    }

    return (
      <ButtonCourseStyled $fonts={font} $styles={buttonStyles} onClick={handleClick}>
        {children}
      </ButtonCourseStyled>
    )
  },
)

ButtonCourse.displayName = 'ButtonCourse'

export default ButtonCourse
